function updateCounter(id, min, max, int) {
    let counter = document.getElementById(id);
    let count = parseInt(localStorage.getItem("count")) || parseInt(min);
    min = parseInt(min);
    max = parseInt(max);
    int = parseInt(int);
  
    function updateCount() {
      let randomNum = Math.random() < 0.5 ? Math.floor(Math.random() * 5) + 1 : Math.floor(Math.random() * 10) + 1;
      let randomSign = Math.random() < 0.7 ? 1 : -1;
      count += randomNum * randomSign;
      count = Math.max(min, Math.min(max, count));
      counter.textContent = count;
      localStorage.setItem("count", count);
    }
  
    setInterval(updateCount, int);
    updateCount();
  }

  function swiperinitialized() {
    var swiper = new Swiper(".mvidSwiper", {
        slidesPerView: 1.2,
        spaceBetween: 10,
        navigation: {
            nextEl: ".u-swiper-next",
            prevEl: ".u-swiper-prev",
        },
        breakpoints: {
            500: { slidesPerView: 1.2, spaceBetween: 7 },
            768: { slidesPerView: 3.2, spaceBetween: 10 },
            1024: { slidesPerView: 4, spaceBetween: 15 },
        },
        pagination: {
          el: ".swiper-pagination",
        },      
        on: {
            init: function () {
                console.log('Swiper initialized');
            },
        }
    });
    document.querySelectorAll('.m-play-button-container').forEach(button => {
        button.addEventListener('click', function () {
            var videoElement = this.closest('.m-video-slider-video').querySelector('.vm-video');
            if (videoElement.paused) {
                videoElement.play();
                videoElement.muted = false;
                this.style.opacity = 0;
                console.log('Video playing');
            } else {
                videoElement.pause();
                this.style.opacity = 0.5;
                console.log('Video paused');
            }
        });
    });
    document.querySelectorAll('.vm-video').forEach(video => {
        video.addEventListener('ended', function () {
            console.log('Video ended, replaying');
            video.play();
        });
    });
}
function reviewSlider() {
    var swiper = new Swiper(".MreviewSlider", {
        slidesPerView: 1,
        spaceBetween: 15,
        loop: true,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
        navigation: {
            nextEl: ".m-swiper-next",
            prevEl: ".m-swiper-prev",
        },
        breakpoints: {
            0: { slidesPerView: 1, spaceBetween: 15 },
            840: { slidesPerView: 2, spaceBetween: 15 },
            1050: { slidesPerView: 3, spaceBetween: 15 },
            1200: { slidesPerView: 4, spaceBetween: 15 },
        },
    });
}